export default __webpack_public_path__ + "static/media/usuarios-icon.580946e3.svg";